import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import ApiConfig from 'src/config/api-config.ts';

export interface ProgramGenerationParameters {
  // Static Parameters
  energy_level: string[];
  non_gym_activity: string[];
  fitness_level: string[];
  movement_insights: string[];
  injuries_limitations?: string[];
  program_duration: string[];
  training_schedule: string[];
  workout_duration: string[];
  training_goal: string[];
  secondary_training_goals?: string[];
  program_intensity: string[];
  gym_equipments?: string[];
  weight_loss_target?: string[];
  rehabilitation_stage?: string[];

  // Dynamic Parameters
  training_goal_details?: string[];
  training_goal_preferences?: string[];
  training_goal_approaches?: string[];
}

export interface ProgramGenerationPayload {
  clientId: string;
  programId?: string;
  parameters: ProgramGenerationParameters;
}

export function useSummarizeInstructionProd() {
  return useMutation({
    mutationFn: async (params: ProgramGenerationPayload) => {
      const response = await axios.post(
        `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.SUMMARIZE_INSTRUCTION_PROD_API_HOST}`,
        { data: { ...params, clientIds: [params.clientId], clientId: undefined } },
        { headers: { 'Content-Type': 'application/json' }, timeout: 600000 },
      );
      return response.data?.result || response.data?.data || response.data;
    },
  });
}
